import React, { Component } from 'react'
import HorizontalList from './/horizontal_list/horizontal_list';
import ThemeImage from './theme_header/header_img';
import './index.less';
class Container extends Component {
    render() {
        return (
            <div className="steetsnap-product-container deja-content-panel">
                <ThemeImage key="head-image" data={this.props.data} streetID={+this.props.streetID}/>
                <HorizontalList key="list" data={this.props.data}/>
            </div>
        )
    }
}

export default Container;


// WEBPACK FOOTER //
// ./src/features/streetSnap/streetInfluencer/component/index.js